module.exports = __webpack_public_path__ + "media/images/icons/check-circle-3fc6711a626a0cfee4d54c0c59a487e5.svg";